import React from "react";

/* Handset — a contact number changing hands. */
export const PhoneIcon = ({ size = 16, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
       aria-hidden="true" focusable="false" className={className}>
    <path d="M8.1 4H5.3A1.8 1.8 0 003.5 6c.3 3.2 1.5 6.2 3.5 8.7 1.8 2.3 4.1 4.1 6.8 5.2a1.8 1.8 0 002.1-.6l1.4-1.9a1.3 1.3 0 00-.3-1.8l-2.2-1.6a1.3 1.3 0 00-1.6.1l-.9.8a11.8 11.8 0 01-3.9-4l.9-.8a1.3 1.3 0 00.2-1.6L8.1 4z"
          stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" />
  </svg>
);

export default PhoneIcon;
